import { useEffect, useState } from "react";

export const useGetAvailableAgent = () => {
    const [numberAvailableAgent, setNumberAvailableAgent] = useState(0);

    useEffect(() => {
        fetch(`${process.env.WEBCHAT_URL}/server/data/pacing/channelCapacity?channel=chat&groups=VAG_Chat_Ion_General`)
            .then((result) => result.json())
            .then((result: { capacity: number }) => {
                setNumberAvailableAgent(result.capacity);
            })
            // eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function
            .catch(() => {});
    }, []);

    return numberAvailableAgent > 0;
};
